// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Conteneur des boutons */
.button-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

/* Style des boutons */
.button-tab {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
  transition: background 0.3s ease-in-out;
}

.button-tab:hover {
  background-color: #0056b3;
}

.button-tab.active {
  background-color: #0056b3;
  border-bottom: 3px solid white;
}

/* Conteneur principal de la galerie */
.gallery-container {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
}

/* Animation pour les filtres */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Filtres de sélection */
.gallery-filters {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  opacity: 0;
  animation: fadeIn 0.4s forwards ease-in-out;
}

.gallery-select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  background-color: #fff;
}

.gallery-select:focus {
  outline: none;
  border-color: #007bff;
}

/* Grille des œuvres */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

/* Animation d'apparition des œuvres */
@keyframes fadeInGallery {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Élément d'œuvre */
.gallery-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  cursor: pointer;
  background-color: #fff;
  opacity: 0;
  transform: translateY(5px);
  animation: fadeInGallery 0.6s forwards ease-out;
}

.gallery-item:hover {
  transform: scale(1.05);
}

.gallery-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 5px;
}

.gallery-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
}

/* Grille des artistes */
.artist-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  max-width: 900px;
  margin: auto;
  gap: 16px;
  padding: 10px;
}

/* Animation pour les cartes d'artistes */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.artist-card {
  background: rgba(255, 162, 74, 0.63);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  opacity: 0;
  animation: fadeInScale 0.5s forwards ease-out;
}

.artist-card:hover {
  transform: scale(1.07);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.artist-image {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 8px;
}

.artist-name {
  font-size: 14px;
  font-weight: bold;
}

.artist-bio {
  font-size: 12px;
  color: gray;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/Arts/Arts.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gEAAgE;EAChE,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mEAAmE;EACnE,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* Conteneur des boutons */\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n/* Style des boutons */\n.button-tab {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  font-weight: bold;\n  transition: background 0.3s ease-in-out;\n}\n\n.button-tab:hover {\n  background-color: #0056b3;\n}\n\n.button-tab.active {\n  background-color: #0056b3;\n  border-bottom: 3px solid white;\n}\n\n/* Conteneur principal de la galerie */\n.gallery-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n/* Animation pour les filtres */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Filtres de sélection */\n.gallery-filters {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  opacity: 0;\n  animation: fadeIn 0.4s forwards ease-in-out;\n}\n\n.gallery-select {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #fff;\n}\n\n.gallery-select:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n/* Grille des œuvres */\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n/* Animation d'apparition des œuvres */\n@keyframes fadeInGallery {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Élément d'œuvre */\n.gallery-item {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  text-align: center;\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  cursor: pointer;\n  background-color: #fff;\n  opacity: 0;\n  transform: translateY(5px);\n  animation: fadeInGallery 0.6s forwards ease-out;\n}\n\n.gallery-item:hover {\n  transform: scale(1.05);\n}\n\n.gallery-image {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.gallery-title {\n  margin-top: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Grille des artistes */\n.artist-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  max-width: 900px;\n  margin: auto;\n  gap: 16px;\n  padding: 10px;\n}\n\n/* Animation pour les cartes d'artistes */\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.artist-card {\n  background: rgba(255, 162, 74, 0.63);\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  opacity: 0;\n  animation: fadeInScale 0.5s forwards ease-out;\n}\n\n.artist-card:hover {\n  transform: scale(1.07);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.artist-image {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-bottom: 8px;\n}\n\n.artist-name {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.artist-bio {\n  font-size: 12px;\n  color: gray;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
